var ChapterDoc, ChapterDocShape, DOCUMENT_SECTIONS_V2_SECTION_TYPE, DocumentSectionsV2Actions, MDA_HANDOUT, MINI_DOCUMENT_DOC_TYPE, MINI_DOC_TEMPLATES, MINI_DS_CHAPTER_PREFIX, MINI_DS_PREFIX, MINI_DS_ROOT_PREFIX, MINI_DS_SECTION_PREFIX, MdaTopicDoc, MiniDSDoc, MiniDSRootDoc, QuestionsStatusesActions, SectionDoc, W, alt, callMethod, chaptersView, createChaptersStructure, discussionsDbView, errorHandlerWithMsg, generateActions, generateGUID, kebabCase, mediator, _ref, _ref1, _ref2;

alt = require('alt');

ChapterDoc = require('lib/db_docs/document_sections_v2_chapter_doc');

ChapterDocShape = require('lib/db_docs/doc_shapes/document_sections_v2_chapter_doc_shape');

SectionDoc = require('lib/db_docs/document_sections_v2_section_doc');

DocumentSectionsV2Actions = require('actions/document_sections_v2_actions');

generateActions = require('actions/utils/generate_actions');

_ref = require('lib/db_docs/doc_types'), MDA_HANDOUT = _ref.MDA_HANDOUT, MINI_DOCUMENT_DOC_TYPE = _ref.MINI_DOCUMENT_DOC_TYPE, DOCUMENT_SECTIONS_V2_SECTION_TYPE = _ref.DOCUMENT_SECTIONS_V2_SECTION_TYPE;

kebabCase = require('lodash').kebabCase;

MdaTopicDoc = require('lib/db_docs/mda_topic_doc');

MiniDSDoc = require('lib/db_docs/mini_ds_doc');

MiniDSRootDoc = require('lib/db_docs/mini_ds_root_doc');

mediator = require('mediator');

QuestionsStatusesActions = require('actions/questions_statuses_actions');

MINI_DOC_TEMPLATES = require('lib/document_sections_v2_templates/templates');

W = require('when/when');

errorHandlerWithMsg = require('lib/app_utils').errorHandlerWithMsg;

_ref1 = require('base/lib/utils'), callMethod = _ref1.callMethod, generateGUID = _ref1.generateGUID;

_ref2 = require('lib/doc_prefixes'), MINI_DS_PREFIX = _ref2.miniDsDoc, MINI_DS_ROOT_PREFIX = _ref2.miniDSRootDoc, MINI_DS_CHAPTER_PREFIX = _ref2.miniDSChapterDoc, MINI_DS_SECTION_PREFIX = _ref2.miniDSSectionDoc;

discussionsDbView = require('lib/document_sections_v2_helper').discussionsDbView;

chaptersView = {
  map: function(doc) {
    if (doc.type === 'document_sections_chapter') {
      return emit(doc.parentDocId, doc);
    }
  }
};

createChaptersStructure = function(doc) {
  var parentDocId, template;
  parentDocId = doc._id;
  template = _.find(MINI_DOC_TEMPLATES, function(docTpl) {
    return docTpl.id === doc.template || 'condition';
  });
  return _.reduce(template.chapters, function(acc, chapter) {
    var chapterId, subchapterDocs;
    chapterId = "" + MINI_DS_CHAPTER_PREFIX + (generateGUID());
    subchapterDocs = chapter.subchapters ? _.map(chapter.subchapters, function(subchapter) {
      return ChapterDocShape.defaults({
        _id: "" + MINI_DS_CHAPTER_PREFIX + (generateGUID()),
        parent: chapterId,
        slug: kebabCase(subchapter.title),
        title: $.t("docsec:templates.chapters." + subchapter.title),
        parentDocId: parentDocId
      });
    }) : [];
    doc = ChapterDocShape.defaults({
      _id: chapterId,
      title: $.t("docsec:templates.chapters." + chapter.title),
      slug: kebabCase(chapter.title),
      subchapters: _.pluck(subchapterDocs, '_id'),
      parentDocId: parentDocId
    });
    acc.rootChapterIds = acc.rootChapterIds.concat(chapterId);
    acc.docs = acc.docs.concat(doc, subchapterDocs);
    return acc;
  }, {
    rootChapterIds: [],
    docs: []
  });
};

module.exports = generateActions({
  autoGenerate: ['closeCreateOrEditDialog', 'fetchSuccess', 'openCreateOrEditDialog'],
  name: 'MiniDSActions',
  actions: {
    dbChange: function(change, _pending, _lastSeq) {
      var currentDocumentId, _ref3, _ref4, _ref5, _ref6;
      currentDocumentId = alt.stores.MiniDSStore.getCurrentDocumentId();
      if (change.deleted || ((_ref3 = change.doc) != null ? _ref3._id : void 0) === currentDocumentId || ((_ref4 = change.doc) != null ? _ref4.docType : void 0) === MINI_DOCUMENT_DOC_TYPE || ((_ref5 = change.doc) != null ? _ref5.type : void 0) === DOCUMENT_SECTIONS_V2_SECTION_TYPE) {
        DocumentSectionsV2Actions.dbChange(change);
      }
      QuestionsStatusesActions.dbChange(change);
      if (((_ref6 = change.doc) != null ? _ref6._id : void 0) === currentDocumentId) {
        return this.dispatch(change);
      }
    },
    fetch: function(_arg) {
      var adapter, dbId, docId;
      dbId = _arg.dbId, docId = _arg.docId;
      this.dispatch();
      adapter = mediator.services.storePersistenceAdapter;
      return MiniDSDoc.at(dbId, docId).fetch().then((function(_this) {
        return function(doc) {
          var chaptersPromise, discussionsPromise, rootPromise;
          rootPromise = MiniDSRootDoc.at(dbId, doc.docRootId).fetch();
          chaptersPromise = adapter.fetchWithView(dbId, 'chaptersView', chaptersView, docId);
          discussionsPromise = adapter.fetchWithView(dbId, 'doc_sec_v2_discussions', discussionsDbView, docId);
          return W.all([rootPromise, chaptersPromise, discussionsPromise]).then(function(_arg1) {
            var chapters, discussions, root;
            root = _arg1[0], chapters = _arg1[1], discussions = _arg1[2];
            DocumentSectionsV2Actions.fetchSuccess({
              alreadyUsedRecommendations: [],
              chapters: chapters,
              discussions: discussions,
              docId: docId,
              recommendations: [],
              root: root
            });
            return _this.actions.fetchSuccess(doc);
          });
        };
      })(this))["catch"](DocumentSectionsV2Actions.fetchFailure);
    },
    createDocument: function(doc, options) {
      var docToCreate;
      this.dispatch();
      docToCreate = _.extend({}, doc, options, {
        _id: "" + MINI_DS_PREFIX + (generateGUID()),
        docRootId: "" + MINI_DS_ROOT_PREFIX + (generateGUID())
      });
      if (docToCreate.docType === MDA_HANDOUT) {
        MdaTopicDoc.at(mediator.project.id, docToCreate.options.parentTopicId).updateAsInstance(callMethod('addHandout', docToCreate._id))["catch"](function(err) {
          return errorHandlerWithMsg(err, $.t('docsec:mini_ds.create_error'));
        });
      }
      return MiniDSDoc.at(mediator.project.id).create(docToCreate).then(this.actions.createDocumentDoc)["catch"](function(err) {
        return errorHandlerWithMsg(err, $.t('docsec:mini_ds.create_error'));
      })["finally"](this.actions.closeCreateOrEditDialog);
    },
    createDocumentDoc: function(doc) {
      var chapterDocs;
      chapterDocs = createChaptersStructure(doc);
      return MiniDSRootDoc.at(mediator.project.id).create({
        _id: doc.docRootId,
        chaptersOrder: chapterDocs.rootChapterIds,
        parentDocId: doc._id
      }).then(function() {
        return ChapterDoc.at(mediator.project.id).createMany(chapterDocs.docs);
      })["catch"](function(err) {
        return errorHandlerWithMsg(err, $.t('docsec:mini_ds.create_doc_root_error'));
      });
    },
    updateDocument: function(doc) {
      this.dispatch();
      return MiniDSDoc.at(mediator.project.id, doc._id).update(doc)["catch"](function(err) {
        return errorHandlerWithMsg(err, $.t('docsec:mini_ds.save_error'));
      })["finally"]((function(_this) {
        return function() {
          return _this.actions.closeCreateOrEditDialog();
        };
      })(this));
    }
  }
});
